import React from 'react';
import styles from './CarregandoSobreposto.module.css';

const CarregandoSobreposto = () => {
  return (
    <div className={styles.sobreposto}>
      <div className={styles.containerCarregamento}>
        <div className={styles.spinner}></div>
        <p className={styles.texto}>Carregando...</p>
      </div>
    </div>
  );
};

export default CarregandoSobreposto;
